export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_03.c987a3bb.jpg";